import { render } from "./TIAddPayModal.vue?vue&type=template&id=796079d6&scoped=true"
import script from "./TIAddPayModal.vue?vue&type=script&lang=js"
export * from "./TIAddPayModal.vue?vue&type=script&lang=js"

import "./TIAddPayModal.vue?vue&type=style&index=0&id=796079d6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796079d6"]])

export default __exports__